/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Section } from 'ui/molecules/Section/Section';

import styles from './NumberedFeatureCards.module.scss';

import { type NumberedFeatureCardsProps } from './NumberedFeatureCards.types';

export const NumberedFeatureCards = ({
  eyebrow,
  title,
  description,
  items,
  columns = 2,
  theme = 'dark',
  background = theme === 'dark' ? '#0e1526' : '#f5f6f9',
  actions,
  className,
}: NumberedFeatureCardsProps) => (
  <Section
    theme={theme}
    background={background}
    extra={eyebrow}
    title={title}
    description={description}
    className={className}
  >
    <div className={cn(styles.cards, styles[`cols${columns}`], theme === 'light' && styles.light)}>
      {items.map((item) => {
        const content = (
          <>
            <span className={styles.cardNum} aria-hidden="true">
              {item.num}
            </span>

            <h3 className={styles.cardTitle}>{item.title}</h3>
            {item.description && <p className={styles.cardDescription}>{item.description}</p>}

            {item.list && (
              <ul className={styles.cardList}>
                {item.list.map((field) => (
                  <li key={field}>{field}</li>
                ))}
              </ul>
            )}
          </>
        );

        return item.href ? (
          <a key={item.num} href={item.href} className={styles.card}>
            {content}
          </a>
        ) : (
          <div key={item.num} className={styles.card}>
            {content}
          </div>
        );
      })}
    </div>

    {actions && <div className={styles.actions}>{actions}</div>}
  </Section>
);
